import { Link } from "react-router-dom";
import Badge from "../../../components/ui/Badge";
import { formatDateRange, LEAVE_STATUS } from "../../leave/leaveUtils";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Dashboard.module.css";

const LeaveCard = ({ leave }) => (
  <>
    {leave.balances.length ? (
      <div className={styles.chips}>
        {leave.balances.map((b) => (
          <span key={b.leaveTypeId} className={styles.balanceChip}>
            {b.leaveTypeName} <strong>{b.available}</strong>/{b.allocated}
          </span>
        ))}
      </div>
    ) : (
      <p className={ui.muted}>No leave balances for {leave.year}.</p>
    )}

    {leave.upcoming.length > 0 && (
      <>
        <h6 className={styles.subheading}>Upcoming</h6>
        <ul className={styles.miniList}>
          {leave.upcoming.slice(0, 3).map((l) => {
            const status = LEAVE_STATUS[l.status] ?? {
              label: l.status,
              tone: "gray",
            };
            return (
              <li key={l.id}>
                <span>
                  <strong>{l.leaveTypeName}</strong> ·{" "}
                  {formatDateRange(l.startDate, l.endDate)}
                </span>
                <Badge tone={status.tone}>
                  {l.status === "pending" ? "Pending" : status.label}
                </Badge>
              </li>
            );
          })}
        </ul>
      </>
    )}

    <div className={styles.rowBetween}>
      <span className={ui.muted}>
        {leave.pendingRequests > 0
          ? `${leave.pendingRequests} waiting for approval`
          : "No pending requests"}
      </span>
      <Link
        to="/me/leaves?file=1"
        className={`${ui.button} ${ui.primary} ${ui.buttonSmall}`}
      >
        <i className="bi bi-plus-lg"></i>
        File leave
      </Link>
    </div>
  </>
);

export default LeaveCard;
